export const KINDS = {
    INDENTED: "Indented",
    FULL: "Full",
} as const;

export type KIND = typeof KINDS[keyof typeof KINDS];
